import { render, staticRenderFns } from "./asset-data.vue?vue&type=template&id=1a37fead"
import script from "./asset-data.vue?vue&type=script&lang=js"
export * from "./asset-data.vue?vue&type=script&lang=js"
import style0 from "./asset-data.vue?vue&type=style&index=0&id=1a37fead&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports